//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";
import Constants from "../../../../../config/Constants";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/lettersen/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveLetters: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/lettersen/edit/save", vo, successCallback, failureCallback);
    },
    batchAddLetters: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/lettersen/edit/batchadd", vo, successCallback, failureCallback);
    },
};

export default EditService;
